import { render, staticRenderFns } from "./AddUserIdAttribute.vue?vue&type=template&id=5e50b51e&"
import script from "./AddUserIdAttribute.vue?vue&type=script&lang=js&"
export * from "./AddUserIdAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports